import React, { useState, useEffect } from 'react'
import { Box, ImageList, ImageListItem, Paper, Modal, Backdrop, Fade, IconButton, Typography, Stack } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { fetchImages } from './backend'
import { LoadingSkeleton } from './LoadingSkeleton'

export function Galerie() {
  const [open, setOpen] = useState(false)
  const [selectedImg, setSelectedImg] = useState(null)
  const [itemData, setItemData] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const loadImages = async () => {
      try {
        setLoading(true)
        setError(null)
        const images = await fetchImages()
        setItemData(images)
      } catch (err) {
        setError('Erreur lors du chargement des images. Veuillez réessayer plus tard.')
        console.error('Erreur lors du chargement des images:', err)
      } finally {
        setLoading(false)
      }
    }
    loadImages()
  }, [])

  const handleOpen = (item) => {
    setSelectedImg(item)
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    setSelectedImg(null)
  }

  return (
    <div style={{ textAlign: 'center', width: '100%' }}>
      <Paper
        elevation={2}
        sx={{
          width: '100%'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            width: '100%'
          }}
        >
          {loading ? (
            <LoadingSkeleton text={'Chargement des images...'} />
          ) : error ? (
            <Typography color='error' sx={{ p: 2 }}>
              {error}
            </Typography>
          ) : (
            <ImageList
              sx={{
                width: { xs: '100%', sm: '60%' },
                height: { xs: '300px', sm: '600px' },
                margin: '0 auto'
              }}
              cols={4}
              rowHeight={{ xs: 182, sm: 164 }}
            >
              {itemData.map((item) => (
                <ImageListItem
                  key={item.id || item.img}
                  onClick={() => handleOpen(item)}
                  style={{ cursor: 'pointer' }}
                  cols={item.cols || 1}
                  rows={item.rows || 1}
                >
                  <img
                    srcSet={`${item.img}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
                    src={`${item.img}?w=164&h=164&fit=crop&auto=format`}
                    alt={item.title}
                    loading='lazy'
                  />
                  <Box sx={{ p: 0.5 }}>
                    <Stack spacing={0.25}>
                      {item.title && (
                        <Typography variant='body2' fontWeight='bold' noWrap>
                          {item.title}
                        </Typography>
                      )}
                      {item.description && (
                        <Typography variant='caption' color='text.secondary'>
                          {item.description}
                        </Typography>
                      )}
                    </Stack>
                  </Box>
                </ImageListItem>
              ))}
            </ImageList>
          )}
        </Box>
      </Paper>
      <Modal
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500
        }}
      >
        <Fade in={open}>
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0,0,0,0.9)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              outline: 'none'
            }}
          >
            <IconButton
              onClick={handleClose}
              style={{
                position: 'absolute',
                top: 10,
                right: 10,
                color: 'white'
              }}
            >
              <CloseIcon />
            </IconButton>
            {selectedImg && (
              <>
                <img
                  src={selectedImg.img}
                  alt={selectedImg.title || 'Full screen'}
                  style={{
                    maxWidth: '90%',
                    maxHeight: '90%',
                    objectFit: 'contain'
                  }}
                />
                <Box
                  sx={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    backgroundColor: 'rgba(0,0,0,0.75)',
                    color: 'white',
                    px: 3,
                    py: 2,
                    textAlign: 'left'
                  }}
                >
                  {selectedImg.title && (
                    <Typography variant='h6' fontWeight='bold' gutterBottom>
                      {selectedImg.title}
                    </Typography>
                  )}
                  {selectedImg.description && (
                    <Typography variant='body2' sx={{ opacity: 0.85, whiteSpace: 'pre-wrap' }}>
                      {selectedImg.description}
                    </Typography>
                  )}
                </Box>
              </>
            )}
          </div>
        </Fade>
      </Modal>
    </div>
  )
}
